// Dependencies
import Bricks from 'bricks.js';

/**
 * Array containing sizes
 * Used by Bricks.js
 */
const sizes = [
  { columns: 2, gutter: 10 },
  { mq: '480px', columns: 2, gutter: 10 },
  { mq: '600px', columns: 2, gutter: 10 },
  { mq: '768px', columns: 3, gutter: 10 },
  { mq: '960px', columns: 3, gutter: 10 },
  { mq: '1024px', columns: 4, gutter: 10 },
  { mq: '1280px', columns: 4, gutter: 10 }
];

/**
 * Set up variable to contain Bricks instance
 * This will allow for re-packing and updating on AJAX success
 */
export let instance = null;

/**
 * Initiate Bricks.js
 * @param {string} attr The data attribute to use
 */
export function bricks(attr) {
  // Stop if nothing is passed
  if (!attr) return false;

  // Store Bricks container
  const target = document.querySelector(`[${attr}]`);

  // Stop if target is not in DOM
  if (!target) return false;

  // Setup instance
  instance = Bricks({
    container: target,
    packed: 'data-packed',
    sizes: sizes
  });

  // Callback functions
  instance.on('pack',() => {
    // Add class to display bricks
    target.classList.add('packed');
  });

  // Event listener for state change
  document.addEventListener('readystatechange', event => {
    // When DOM has loaded
    if (event.target.readyState === 'complete') {
      // Setup resize listener
      instance.resize(true);
      // Pack elements
      instance.pack();
    }
  });
}
